import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSocialListeningSentimentStore = defineStore('socialListeningSentiment', () => {
  const pending = ref({});

  function setPendingState(sourceAndId, value) {
    if (value) {
      pending.value[sourceAndId] = true;
    } else {
      delete pending.value[sourceAndId];
    }
  }

  function isPending(sourceAndId) {
    return Boolean(pending.value[sourceAndId]);
  }

  return {
    pending,
    setPendingState,
    isPending,
  };
});
